export default function extractMonthYearInRange(start_date_str, end_date_str) {
    // Convert input strings to Date objects
    const start_date = new Date(start_date_str);
    const end_date = new Date(end_date_str);
  
    // Create an array to store the month and year combinations
    const month_year_list = [];
  
    // Define a function to format the date as "MMM YYYY" (e.g., "Jun 2023")
    function formatMonthYear(date) {
        
        const options = { year: 'numeric', month: 'short' };
        return date.toLocaleDateString('en-US', options);
    }
  
    // Loop through the dates from start_date to end_date
    let current_date = new Date(start_date);
    while (current_date <= end_date) {
        // Add the formatted month and year to the array
        month_year_list.push(formatMonthYear(new Date(current_date))); // Clone date to avoid mutation issues
      
        // Move to the first day of the next month
        current_date.setDate(1); // Reset to the first of the month
        current_date.setMonth(current_date.getMonth() + 1); // Move to the next month
    }
    // Return the resulting array
    return month_year_list;
}
  
  
  
  